export default function ContactSection() {
  return (
    <section className="w-full py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 mb-4">
            <i className="ri-mail-line text-primary-600 text-sm"></i>
            <span className="text-primary-700 text-xs font-semibold">Contact Us</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            联系
            <span className="text-primary-500">我们</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto mb-8">
            有料要爆？合作洽谈？欢迎通过以下方式联系我们
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-4xl mx-auto">
          {[
            {
              icon: 'ri-mail-send-line',
              title: '爆料投稿',
              desc: 'admin@mvziioc.cn',
              sub: '欢迎瓜友投稿爆料',
            },
            {
              icon: 'ri-briefcase-line',
              title: '商务合作',
              desc: 'biz@mvziioc.cn',
              sub: '品牌合作·广告投放',
            },
            {
              icon: 'ri-shield-check-line',
              title: '版权申诉',
              desc: 'dmca@mvziioc.cn',
              sub: '24小时内处理',
            },
            {
              icon: 'ri-customer-service-2-line',
              title: '用户反馈',
              desc: 'feedback@mvziioc.cn',
              sub: '工作日24h回复',
            },
          ].map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-2xl p-5 md:p-6 text-center hover:bg-background-200/70 transition-colors"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="text-foreground-950 font-semibold text-sm mb-1">{item.title}</h3>
              <p className="text-primary-600 text-xs font-medium mb-1">{item.desc}</p>
              <p className="text-foreground-500 text-xs">{item.sub}</p>
            </div>
          ))}
        </div>

        <div className="max-w-2xl mx-auto mt-12 pt-8 border-t border-background-200">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
            <div>
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-2">
                <i className="ri-video-line text-lg"></i>
              </span>
              <p className="text-foreground-950 font-heading text-2xl font-bold">12,000+</p>
              <p className="text-foreground-500 text-xs">吃瓜视频资源</p>
            </div>
            <div>
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-2">
                <i className="ri-user-smile-line text-lg"></i>
              </span>
              <p className="text-foreground-950 font-heading text-2xl font-bold">500万+</p>
              <p className="text-foreground-500 text-xs">月活跃瓜友</p>
            </div>
            <div>
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-2">
                <i className="ri-refresh-line text-lg"></i>
              </span>
              <p className="text-foreground-950 font-heading text-2xl font-bold">每日更新</p>
              <p className="text-foreground-500 text-xs">365天不间断</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
